import { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import { FormikErrorMessage } from "../../../Layout/Common/fromikErrorMessage";

const validationSchema = Yup.object({
  guestName: Yup.string()
    .trim()
    .matches(/^[A-Za-z\s.'-]{2,}$/, "Enter a valid name")
    .required("Contact name is required"),
  guestEmail: Yup.string().trim().email("Enter a valid email address").required("Email address is required"),
  guestPhone: Yup.string()
    .matches(/^\+?[0-9\s-]{7,15}$/, "Enter a valid phone number")
    .required("Phone number is required"),
});

// Pushes the current field values up to the parent setters whenever they change.
const SyncToParent = ({ setGuestDetail }) => {
  const { values } = useFormikContext();
  useEffect(() => {
    setGuestDetail((prev) => ({
      ...prev,
      name: values.guestName,
    }));
  }, [values.guestName]);

  useEffect(() => {
    setGuestDetail((prev) => ({
      ...prev,
      mail: values.guestEmail,
    }));
  }, [values.guestEmail]);

  useEffect(() => {
    setGuestDetail((prev) => ({
      ...prev,
      phone: values.guestPhone,
    }));
  }, [values.guestPhone]);
  return null;
};

export const GuestDetailsForm = ({ setGuestDetail, formRef, initialDetail }) => {
  return (
    <div className="guest-info-container mt-5">
      <div className="shipping-method express-shipping">
        <h2>Contact Details</h2>
      </div>
      <div className="guest-info-body ">
        <Formik
          innerRef={formRef}
          initialValues={{
            guestName: initialDetail?.name || "",
            guestEmail: initialDetail?.mail || "",
            guestPhone: initialDetail?.phone || "",
          }}
          validationSchema={validationSchema}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={() => {}}
        >
          {({ touched, errors }) => (
            <Form className="col-lg-10">
              <SyncToParent setGuestDetail={setGuestDetail} />
              <div className="row">
                <div className="col-md-12">
                  <div className="floating-input mb-4">
                    <Field
                      id="guestName"
                      name="guestName"
                      className={`form-control form-input ${touched.guestName && errors.guestName && "error-message"}`}
                      type="text"
                      placeholder=""
                      required={true}
                    />
                    <label htmlFor="guestName">
                      Contact Name
                      <span className="gl-form-asterisk">*</span>
                    </label>
                    <ErrorMessage name="guestName">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                  </div>
                  <div className="floating-input mb-4">
                    <Field
                      id="guestEmail"
                      name="guestEmail"
                      className={`form-control form-input ${
                        touched.guestEmail && errors.guestEmail && "error-message"
                      }`}
                      type="email"
                      placeholder=""
                      required={true}
                    />
                    <label htmlFor="guestEmail">
                      Email Address
                      <span className="gl-form-asterisk">*</span>
                    </label>
                    <ErrorMessage name="guestEmail">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                  </div>
                  <div className="floating-input mb-4">
                    <Field
                      id="guestPhone"
                      name="guestPhone"
                      className={`form-control form-input ${
                        touched.guestPhone && errors.guestPhone && "error-message"
                      }`}
                      type="tel"
                      placeholder=""
                      required={true}
                    />
                    <label htmlFor="guestPhone">
                      Phone Number
                      <span className="gl-form-asterisk">*</span>
                    </label>
                    <ErrorMessage name="guestPhone">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
